export enum QuestResponseType {
  PDF,
  CSV,
}

export enum QuestAccountsPayableFilterDateBy {
  emission,
  dueDate,
  payment,
}

export enum QuestAccountsPayableReportType {
  emission,
  dueDate,
  payment,
  accountPlans,
  bankAccount,
  planAccountSynthetic,
}

export interface QuestAccountsPayableRequest {
  responseType: QuestResponseType;
  companiesIds?: string;
  situationOpen: boolean;
  situationSettled: boolean;
  filterDateBy: QuestAccountsPayableFilterDateBy;
  reportType: QuestAccountsPayableReportType;
  accountsPlanIds?: string;
  documentTypeIds?: string;
  costCenterIds?: string;
  bankAccountIds?: string;
  supplierIds?: string;
  employeeIds?: string;
  startDate: string;
  endDate: string;
}

export const REPORT_ACCOUNTS_PAYABLE_FILTER_DATE_BY_FORMAT = {
  EMISSION: QuestAccountsPayableFilterDateBy.emission,
  DUE: QuestAccountsPayableFilterDateBy.dueDate,
  PAY: QuestAccountsPayableFilterDateBy.payment,
};

export const REPORT_ACCOUNTS_PAYABLE_REPORT_TYPE = {
  EMISSION: QuestAccountsPayableReportType.emission,
  DUE: QuestAccountsPayableReportType.dueDate,
  PAY: QuestAccountsPayableReportType.payment,
  PLAN_ACCOUNT: QuestAccountsPayableReportType.accountPlans,
  BANK_ACCOUNT: QuestAccountsPayableReportType.bankAccount,
  PLAN_ACCOUNT_SYNTHETIC: QuestAccountsPayableReportType.accountPlans,
};
